var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SubTable from '../SubTable.vue';
var TabTable = (function (_super) {
    __extends(TabTable, _super);
    function TabTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShowBusiness = '0';
        return _this;
    }
    TabTable.prototype.selectionChange = function (rows, row) {
        console.log('selectionChange>>>', rows);
        var validRows = rows.filter(function (item) { return item && item.goods_id; });
        if (this.type === 'unselected') {
            validRows.forEach(function (item) {
                item.selected_deliver_order = item.deliver_order_items;
            });
        }
        this.$emit('selectChange', validRows, row);
    };
    TabTable.prototype.selectAll = function (rows) {
        console.log('selectAll>>>', rows);
        if (this.type === 'unselected') {
            rows.forEach(function (item) {
                item.selected_deliver_order = item.deliver_order_items;
            });
        }
        this.$emit('selectChange', rows, null, true);
    };
    TabTable.prototype.rowDeliverSelectionChange = function (rows, row) {
        this.$refs.table.toggleRowSelection(row, rows.length > 0);
        if (this.type === 'unselected') {
            row.selected_deliver_order = rows || [];
            row.hideInUnselect = row.selected_deliver_order.length !== row.deliver_order_items.length;
            this.$emit('selectChange', this.$refs.table.selection);
        }
        console.log('rowDeliverSelectionChange>>>', rows, this.$refs.table);
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], TabTable.prototype, "data", void 0);
    __decorate([
        Prop({
            required: true,
            type: String,
            default: 'unselected'
        })
    ], TabTable.prototype, "type", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], TabTable.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], TabTable.prototype, "isConfig", void 0);
    TabTable = __decorate([
        Component({
            components: {
                SubTable: SubTable
            }
        })
    ], TabTable);
    return TabTable;
}(Vue));
export default TabTable;
